import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.stripe_event_status_ */
export type StripeEventStatusId = string & { __brand: 'StripeEventStatusId' }

/** Represents the table public.stripe_event_status_ */
export default interface StripeEventStatusTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<StripeEventStatusId, StripeEventStatusId, StripeEventStatusId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type StripeEventStatus = Selectable<StripeEventStatusTable>

export type StripeEventStatusInitializer = Insertable<StripeEventStatusTable>

export type StripeEventStatusMutator = Updateable<StripeEventStatusTable>

export const stripeEventStatusId =
  z.string() as unknown as z.Schema<StripeEventStatusId>

export const stripeEventStatus = z.object({
  id: stripeEventStatusId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<StripeEventStatus>

export const stripeEventStatusInitializer = z.object({
  id: stripeEventStatusId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<StripeEventStatusInitializer>

export const stripeEventStatusMutator = z.object({
  id: stripeEventStatusId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<StripeEventStatusMutator>
